<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import * as compare from '@utils/comparers'
import formatDate from '@utils/format-date'
import Specifications from './specifications'
import FinalizeDocument from './finalize-document'
import FinalizeDocumentReminder from './finalize-document-reminder'
import Loading from '@views/loading-modal-window'

export default {
  metaInfo: {
    title: 'Document',
    meta: [{ name: 'description', content: 'Document' }],
  },
  name: 'Document',
  components: {
    Layout,
    Specifications,
    FinalizeDocument,
    Loading,
    FinalizeDocumentReminder,
  },
  props: {
    document: {
      type: Object,
      default: () => {
        const emptyObj = {}
        return emptyObj
      },
    },
  },
  data() {
    return {
      loading: false,
      activaTab: 'mainInformation',
      valid: true,
      fromWarehouse: [],
      fromWarehouseLoading: false,
      toWarehouse: [],
      toWarehouseLoading: false,
      fromOrganizationsLoading: false,
      fromOrganizations: [],
      item: {
        type: this.document.type,
        from: this.document.from,
        fromWarehouse: this.document.fromWarehouse,
        to: this.document.to,
        toWarehouse: this.document.toWarehouse,
      },
      rules: {
        type: [x => !!x || this.$t('validation__is_required')],
        from: [x => !!x || this.$t('validation__is_required')],
        fromWarehouse: [x => !!x || this.$t('validation__is_required')],
        to: [x => !!x || this.$t('validation__is_required')],
        toWarehouse: [x => !!x || this.$t('validation__is_required')],
      },
      finalizeDocument: false,
      specifications: [],
      hasChanges: false,
      finalizingLoading: false,
      currentDocument: {},
      finalizeReminder: false,
      nextUrl: null,
    }
  },
  computed: {
    documentType() {
      return this.item.type
    },
    defaultOrganization() {
      return this.$store.state.data.myOrganization
    },
    type() {
      return this.$store.getters['data/getDictionary']('documenttype').map(item=>{
        item.translatedName = this.$t(`documenttype.${item.code}.name`);
        return item
      })
    },
    from() {
      const orgs = this.$store.getters['data/getOrganization']
      switch (this.documentType) {
        case 2:
        case 4:
          return orgs.filter(elem => elem.id === this.defaultOrganization)
        default:
          return orgs
      }
    },
    to() {
      const orgs = this.$store.getters['data/getOrganization']
      switch (this.documentType) {
        case 1:
          return orgs.filter(elem => elem.id === this.defaultOrganization)
        case 2:
          return orgs.filter(elem => elem.id !== this.defaultOrganization)
        default:
          return orgs
      }
    },
    currentFrom() {
      return this.item.from
    },
    currentFromWarehouse() {
      return this.item.fromWarehouse
    },
    currentTo() {
      return this.item.to
    },
    isFinalized() {
      return this.document.status === 2
    },
    hasSpecs() {
      return this.specifications.length > 0
    },
    isMerge() {
      return this.item.type === 4
    },
  },
  watch: {
    currentFrom(value) {
      this.fromWarehouseLoading = true
      this.item.fromWarehouse = null
      api.getOrganizationChild(value).then(response => {
        this.fromWarehouse = response.sort(compare.byShortName)
        if (response.length === 1) this.item.fromWarehouse = response[0].id
        else {
          const organization = this.$store.getters['data/getOrganization'].find(
            elem => elem.id === value
          )
          const mainWarehouseId = organization.mainWarehouse || null
          if (mainWarehouseId) {
            const main = response.find(elem => elem.id === mainWarehouseId)
            if (main) this.item.fromWarehouse = main.id
          }
        }
        this.fromWarehouseLoading = false
      })
    },
    currentFromWarehouse(value) {
      if (this.isMerge) this.item.toWarehouse = value
    },
    currentTo(value) {
      this.toWarehouseLoading = true
      this.item.toWarehouse = null
      api.getOrganizationChild(value).then(response => {
        this.toWarehouse = response.sort(compare.byShortName)
        if (response.length === 1) this.item.toWarehouse = response[0].id
        else {
          const organization = this.$store.getters['data/getOrganization'].find(
            elem => elem.id === value
          )
          const mainWarehouseId = organization.mainWarehouse || null
          if (mainWarehouseId) {
            const main = response.find(elem => elem.id === mainWarehouseId)
            if (main) this.item.toWarehouse = main.id
          }
        }
        this.toWarehouseLoading = false
      })
    },
    item: {
      handler(value) {
        for (const item in value) {
          if (value[item] !== this.document[item]) {
            this.hasChanges = true
            return
          }
          this.hasChanges = false
        }
      },
      deep: true,
    },
  },
  created() {
    this.fromWarehouseLoading = true
    this.toWarehouseLoading = true
    api.getOrganizationChild(this.document.from).then(response => {
      this.fromWarehouse = response.sort(compare.byShortName)
      this.fromWarehouseLoading = false
    })
    api.getOrganizationChild(this.document.to).then(response => {
      this.toWarehouse = response.sort(compare.byShortName)
      this.toWarehouseLoading = false
    })
    Object.assign(this.currentDocument, this.item)
    if (this.document.type === 5) this.getOrganizations()
  },
  mounted() {
    this.$root.$on('whant-close-document', e => {
      this.nextUrl = e
      this.finalizeReminderCall()
    })
  },
  beforeDestroy() {
    this.$root.$off('whant-close-document', this.finalizeReminderCall())
  },
  methods: {
    close() {
      if (this.nextUrl) {
        this.$router.push(this.nextUrl)
      } else {
        if (!this.$route.params.serial) {
          this.$router.push({
            name: 'documents',
            params: this.$route.params.documentType,
          })
        }
      }
    },
    finalizeReminderCall() {
      if (this.isFinalized) return this.close()
      if (!this.hasSpecs) return this.close()
      else this.finalizeReminder = true
    },
    finalizeReminderClose() {
      this.finalizeReminder = false
    },
    dateFormat(date) {
      return formatDate(date)
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    updateDocument() {
      if (this.$refs.documentForm.validate()) {
        this.loading = true
        const data = {
          id: this.document.id,
          ...this.item,
        }
        api.updateDocument(data).then(response => {
          this.loading = false
          Object.assign(this.currentDocument, this.item)
          this.hasChanges = false
        })
      }
    },
    saveChanges() {
      return new Promise((resolve, reject) => {
        if (this.$refs.documentForm.validate()) {
          // this.finalizingLoading = true
          const data = {
            id: this.document.id,
            ...this.item,
          }
          api
            .updateDocument(data)
            .then(response => {
              this.hasChanges = false
              resolve(response)
            })
            .catch(error => reject(error))
        } else {
          // this.finalizingLoading = false
          reject(Error())
        }
      })
    },
    discardChanges() {
      return new Promise(resolve => {
        this.item = {
          type: this.document.type,
          from: this.document.from,
          fromWarehouse: this.document.fromWarehouse,
          to: this.document.to,
          toWarehouse: this.document.toWarehouse,
        }
        resolve()
      })
    },
    getOrganizations() {
      const myOrganizationId = this.$store.state.data.myOrganization
      const myOrganizations = this.$store.getters['data/getOrganization'].find(
        elem => elem.id === myOrganizationId
      )
      this.item.to = myOrganizationId
      this.fromOrganizations.push(myOrganizations)
    },
  },
}
</script>

<template>
  <Layout>
    <div
      v-if="document.status === 1"
      slot="actionButton"
    >
      <!-- <v-btn
        v-if="item.type === 1"
        disabled
        color="secondary"
      >
        {{ $t('buttons__uploadSpecifications') }}
      </v-btn> -->
      <v-btn
        :disabled="!hasSpecs"
        :dark="hasSpecs"
        color="primary"
        @click.native="finalizeDocument = true"
      >
        {{ $t('buttons__finalize') }}
      </v-btn>
    </div>
    <v-container
      fluid
      class="whiteBg">
      <p class="headline">
        {{ $t('label__document') }} #{{ document.number }} ({{ dateFormat(document.createTime) }})
      </p>
      <p class="headline">
        {{ $t('label__status') }}: <span :class="{finalized : isFinalized}">{{ $t(`documentstatus.${document.status}.name`) }}</span>
      </p>
      <v-tabs v-model="activaTab">
        <v-tab :href="`#mainInformation`">
          {{ $t('tabs__main_information') }}
        </v-tab>
        <v-tab :href="`#specifications`">
          {{ $t('tabs__specifications') }}
        </v-tab>
      </v-tabs>
    </v-container>
    <v-tabs-items v-model="activaTab">
      <v-tab-item :id="`mainInformation`">
        <v-container fluid>
          <v-layout wrap>
            <v-flex lg4>
              <v-form
                ref="documentForm"
                v-model="valid"
                lazy-validation
              >
                <v-select
                  :items="type"
                  :label="$t('label__type')"
                  v-model="item.type"
                  :rules="rules.type"
                  :readonly="isFinalized || hasSpecs"
                  item-text="translatedName"
                  item-value="code"
                  required
                  autocomplete
                />
                <v-select
                  :items="this.$route.params.documentType === 'writeOff' ? fromOrganizations : from"
                  :label="$t('label__from')"
                  v-model="item.from"
                  :rules="rules.from"
                  :readonly="isFinalized || hasSpecs"
                  :loading="fromOrganizationsLoading"
                  item-text="shortName"
                  item-value="id"
                  required
                  autocomplete
                />
                <v-select
                  :items="fromWarehouse"
                  :label="$t('label__fromWarehouse')"
                  :disabled="!item.from"
                  :readonly="isFinalized || hasSpecs"
                  :rules="rules.fromWarehouse"
                  :loading="fromWarehouseLoading"
                  v-model="item.fromWarehouse"
                  item-text="shortName"
                  item-value="id"
                  required
                  autocomplete
                />
                <v-select
                  v-if="item.type !== 5"
                  :items="to"
                  :label="$t('label__to')"
                  v-model="item.to"
                  :rules="rules.to"
                  :readonly="isMerge || isFinalized || hasSpecs"
                  item-text="shortName"
                  item-value="id"
                  required
                  autocomplete
                />
                <v-select
                  v-if="item.type !== 5"
                  :items="toWarehouse"
                  :label="$t('label__toWarehouse')"
                  :disabled="!item.to"
                  :readonly="isMerge || isFinalized || hasSpecs"
                  :rules="rules.toWarehouse"
                  :loading="toWarehouseLoading"
                  v-model="item.toWarehouse"
                  item-text="shortName"
                  item-value="id"
                  required
                  autocomplete
                />
              </v-form>
              <small>* {{ $t('label__requier_small_text') }}</small>
              <div class="btnWrapper">
                <v-btn
                  v-if="!isFinalized"
                  :disabled="loading || !hasChanges"
                  :loading="loading"
                  color="success"
                  @click="updateDocument"
                >
                  {{ $t('buttons__update') }}
                </v-btn>
                <v-btn
                  :disabled="loading"
                  color="secondary"
                  @click="finalizeReminderCall()"
                >
                  {{ isFinalized ? $t('buttons__close') : $t('buttons__cancel') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item :id="`specifications`">
        <specifications
          :current-document="currentDocument"
          @update:spec="specifications = $event"
        />
      </v-tab-item>
    </v-tabs-items>
    <finalize-document
      :dialog="finalizeDocument"
      :document-id="document.id"
      :specs="specifications"
      :has-changes="hasChanges"
      :save-changes-handler="saveChanges"
      :discard-changes-handler="discardChanges"
      @close-finalize-modal="finalizeDocument = false"
    />
    <finalize-document-reminder
      :dialog="finalizeReminder"
      :document-id="document.id"
      @success="close()"
      @cancel="finalizeReminderClose()"
      @close="close()"
    />
    <loading
      :dialog="finalizingLoading"
      :message="$t('message__finalizing')"
    />
  </Layout>
</template>

<style lang="scss" scoped>
.btnWrapper {
  margin-top: 26px;
  margin-left: -8px;
}
.finalized {
  font-weight: 500;
  color: #4caf50;
}
</style>
